function FreezedContainer(container) {
  this.container = container;
}
FreezedContainer.prototype.addChild = function (child) {
  this.container.addChild(child);
}
FreezedContainer.prototype.disableInteraction = function () {
  delete this.container.hitArea;
  this.container.interactive = false;
  this.container.__pbc_block_interaction = true;
  delete this.container.__zindex;
}
FreezedContainer.prototype.removeChild = function (child) {
  this.container.removeChild(child);
}
FreezedContainer.prototype.cacheAsBitmap = function (cache) {
  this.container.cacheAsBitmap = cache;
}
FreezedContainer.prototype.getParent = function () {
  return this.container.parent;
}
FreezedContainer.prototype._containerUpdateTransform = function (container) {
  //console.log('update container');
  //const total = container.children.length;
  //for (let i = 0; i < total; i++) {
    //console.log('update container child', i);
    //const childContainer = container.children[i];
    //this._containerUpdateTransform(childContainer);
  //}
  container.containerUpdateTransform();
}
FreezedContainer.prototype.containerUpdateTransform = function () {
  this._containerUpdateTransform(this.container);
}
FreezedContainer.prototype.destroy = function (o) {
  this.container.destroy(o);
}
FreezedContainer.prototype.getWorldTransform = function () {
  return this.container.worldTransform;
}
FreezedContainer.prototype.getLocalTransform = function () {
  return this.container.localTransform;
}
FreezedContainer.prototype.getBounds = function () {
  return this.container.getBounds();
}

export default FreezedContainer;
